/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DynamicDeviceVm,
    DynamicDeviceVmFromJSON,
    DynamicDeviceVmFromJSONTyped,
    DynamicDeviceVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface DynamicDeviceVmPaginatedSearchResponse
 */
export interface DynamicDeviceVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<DynamicDeviceVm>}
     * @memberof DynamicDeviceVmPaginatedSearchResponse
     */
    items?: Array<DynamicDeviceVm> | null;
    /**
     * 
     * @type {number}
     * @memberof DynamicDeviceVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DynamicDeviceVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof DynamicDeviceVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof DynamicDeviceVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DynamicDeviceVmPaginatedSearchResponse
     */
    size?: number;
}

export function DynamicDeviceVmPaginatedSearchResponseFromJSON(json: any): DynamicDeviceVmPaginatedSearchResponse {
    return DynamicDeviceVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function DynamicDeviceVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicDeviceVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(DynamicDeviceVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function DynamicDeviceVmPaginatedSearchResponseToJSON(value?: DynamicDeviceVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(DynamicDeviceVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


